import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseStatsDto } from '../../../shared/modules/base/dtos/base-stats.dto';

/**
 * Customer stats DTO
 */
@CaslSubject(AppSubjectEnum.CUSTOMER)
export class CustomersStatsDto extends BaseStatsDto {
  active!: number;
  onHold!: number;
  closed!: number;
}
